import React from "react";

import { Link, useSearchParams } from "react-router-dom";

import { Header } from "../components/layout/header";
import { Button } from "../components/ui/button";
import { config } from "../config";
import { useTranslations } from "../hooks/use-translations";

export const AccountCreatedPage = (): React.JSX.Element => {
  const { translations } = useTranslations();
  const [searchParams] = useSearchParams();
  const emailParam = searchParams.get(`email`) ?? ``;
  const lastSentAt = new Date().toISOString();
  const retryAfterMinutes = Number(config.delayToResendAccountConfirmationEmails);
  const search = new URLSearchParams();

  search.set(`email`, emailParam);
  search.set(`lastSentAt`, lastSentAt);
  search.set(`retryAfterMinutes`, String(retryAfterMinutes));

  const redirectUrl = `/resend-confirmation-email?${search.toString()}`;

  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <div className="flex flex-1 items-center justify-center p-4">
        <div className="w-full max-w-md">
          <h1 className="mb-4 text-center text-2xl" data-testid="page-title">
            {translations.register.success}
          </h1>
          <p className="mb-4 text-center">{translations.register.successInstructions}</p>
          <Link to={redirectUrl}>
            <Button className="mt-4 w-full">{translations.resendConfirmationEmail.resendButton}</Button>
          </Link>
        </div>
      </div>
    </div>
  );
};
